import { inject } from '@angular/core';
import type {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RouterStateSnapshot,
} from '@angular/router';
import { Location } from '@freelancer/location';
import { LoadshiftTermsPromptService } from './loadshift-terms-prompt.service';

export const LoadshiftTermsPromptOverridesGuard = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): ReturnType<CanActivateFn> => {
  const loadshiftTermsPromptService = inject(LoadshiftTermsPromptService);
  const location = inject(Location);

  const { searchParams } = new URL(location.href);

  if (
    searchParams.has('no_loadshift_terms_prompt') &&
    searchParams.get('no_loadshift_terms_prompt') !== 'false'
  ) {
    loadshiftTermsPromptService.setIsLoadshiftTermsPromptDisabled(true);
  }

  return true;
};
